import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { IJobBase, JobWorkingForm } from '../../../types'
import { getFormattedAmount } from '../../../utils'
import styles from './index.module.scss'

type Props = {
  job: IJobBase
  isSignedIn?: boolean
}

export const JobContentApplicationGuidelines: FC<Props> = ({ job, isSignedIn = false }) => {
  const { t } = useTranslation(['jobs-[job_slug]', 'jobs'])

  if (!isSignedIn) {
    return (
      <div className={styles.container}>
        <table className={styles.content}>
          <tbody>
            <tr className={styles.tdGroup}>
              <th className={styles.firstLabelTd}>{t('募集形態')}</th>
              <td className={styles.itemTd}>{t(`jobs:${job?.typeOfPosition}`)}</td>
            </tr>
            {job?.primaryJobCategory && (
              <tr className={styles.tdGroup}>
                <th className={styles.labelTd}>{t('職種')}</th>
                <td className={styles.itemTd}>
                  <div className={styles.listItem}>{job?.primaryJobCategory.name}</div>
                </td>
              </tr>
            )}
            {job?.address && !(job?.workingForm === JobWorkingForm.REMOTE_ONLY) && (
              <tr className={styles.tdGroup}>
                <th className={styles.labelTd}>{t('勤務地')}</th>
                <td className={styles.itemTd}>{job?.address}</td>
              </tr>
            )}
            {!(job?.minMonthlySalary === '0' && job?.maxMonthlySalary === '0') && (
              <tr className={styles.tdGroup}>
                <th className={styles.lastLabelTd}>{t('月収')}</th>
                <td className={styles.lastItemTd}>
                  {getFormattedAmount(Number(job?.minMonthlySalary), job?.currencyUnit)}
                  {' - '}
                  {getFormattedAmount(Number(job?.maxMonthlySalary), job?.currencyUnit)}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <table className={styles.content}>
        <tbody>
          <tr className={styles.tdGroup}>
            <th className={styles.firstLabelTd}>{t('募集形態')}</th>
            <td className={styles.firstItemTd}>{t(`jobs:${job?.typeOfPosition}`)}</td>
          </tr>
          {job?.primaryJobCategory && (
            <tr className={styles.tdGroup}>
              <th className={styles.labelTd}>{t('職種')}</th>
              <td className={styles.itemTd}>
                <div className={styles.listItem}>{job?.primaryJobCategory.name}</div>
              </td>
            </tr>
          )}
          {job?.address && !(job?.workingForm === JobWorkingForm.REMOTE_ONLY) && (
            <tr className={styles.tdGroup}>
              <th className={styles.labelTd}>{t('勤務地')}</th>
              <td className={styles.itemTd}>{job?.address}</td>
            </tr>
          )}
          {!(job?.minMonthlySalary === '0' && job?.maxMonthlySalary === '0') && (
            <tr className={styles.tdGroup}>
              <th className={styles.labelTd}>{t('月収')}</th>
              <td className={styles.itemTd}>
                {getFormattedAmount(Number(job?.minMonthlySalary), job?.currencyUnit)}
                {' - '}
                {getFormattedAmount(Number(job?.maxMonthlySalary), job?.currencyUnit)}
              </td>
            </tr>
          )}
          {job?.tokenGrant ? (
            <tr className={styles.tdGroup}>
              <th className={styles.labelTd}>{t('トークンの有無')}</th>
              <td className={styles.itemTd}>{t('有り')}</td>
            </tr>
          ) : (
            <tr className={styles.tdGroup}>
              <th className={styles.labelTd}>{t('トークンの有無')}</th>
              <td className={styles.itemTd}>Negotiation</td>
            </tr>
          )}
          {job?.skills.length > 0 && (
            <tr className={styles.tdGroup}>
              <th className={styles.labelTd}>{t('スキル')}</th>
              <td className={styles.itemTd}>
                <div className={styles.list}>
                  {job?.skills.map((skill) => (
                    <div key={skill.id} className={styles.listItem}>
                      {skill.name}
                    </div>
                  ))}
                </div>
              </td>
            </tr>
          )}
          <tr className={styles.tdGroup}>
            <th className={styles.labelTd}>{t('経験年数')}</th>
            <td className={styles.itemTd}>{t(`jobs:${job?.workExperience}`)}</td>
          </tr>
          <tr className={styles.tdGroup}>
            <th className={styles.lastLabelTd}>{t('リモートの可否')}</th>
            <td className={styles.lastItemTd}>{t(`jobs:${job?.workingForm}`)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
